<template>
	<div>
		<div class="loading_mask" v-show="visible"></div>
		<div class="loading" v-show="visible">
			<i class="iconfont">&#xe613;</i>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			visible: false,
			message: ''
		};
	},

	mounted() {},
	methods: {}
};
</script>

<style lang="scss" scoped>
@import '../style/common';

.loading_mask {
	position: fixed;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999;
}

.loading {
	position: fixed;
	left: 50%;
	top: 50%;
	transform: translateY(-50%);
	margin-left: px2rem(-180rem);
	width: px2rem(360rem);
	padding: px2rem(60rem) 0;
	text-align: center;
	@include borderRadius(5px);
	background: $c_ff;
	z-index: 9999;
	> i {
		font-size: px2rem(60rem);
	}
	.iconfont {
		display: inline-block;
		font-size: px2rem(60rem);
		animation: loading 1.5s infinite linear;
	}
}

@keyframes loading {
	100% {
		transform: rotate(360deg);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue